import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthServiceLocal } from 'src/@order/services/auth.service';

export const noAuthGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const authService = inject(AuthServiceLocal);

  const userToken = localStorage.getItem('PWAToken');
  if (userToken) {
    router.navigate(['/order/home']);
    return false;
  }

  const userId = route.queryParamMap.get('userId');
  if (!userId) {
    return true;
  }

  const res = await authService.getCustomerDetails({ userId });
  if (res) {
    router.navigate(['/order/home']);
    return false;
  }
  return true;
};
